import styled from 'styled-components';

export const Avatar = styled.div`
  width: 40px;
  height: 40px;
  line-height: 40px !important;
  border-radius: 100%;
  overflow: hidden;
  font-size: 0.8em;
  text-align: center;
  color: white;
  vertical-align: middle;
  font-weight: 800;
  display: inline-block;
  background-size: cover;
  background-position: center center;
  box-shadow: 0 0 0 2px inset rgba(0, 0, 0, 0.05);
`;
